import React, { useState, useEffect } from "react";

const LinkBox = props => {
  useEffect(() => {
    if (props.view !== "mobile") {
      return;
    }

    var linkBoxRelatedMobileNode = document.getElementById(
      "linkbox-related-mobile"
    );
    var mobileLinkBox = document.querySelector(".link-box.mobile");

    if (
      linkBoxRelatedMobileNode != null &&
      mobileLinkBox != null &&
      props.Data.quickLinks &&
      !linkBoxRelatedMobileNode.contains(mobileLinkBox)
    ) {
      linkBoxRelatedMobileNode.appendChild(mobileLinkBox);
    }
  }, [props.view, props.Data.quickLinks]);

  return (
    <div className={"link-box " + props.view}>
      {props.Data.heading && (
        <span className="heading">{props.Data.heading}</span>
      )}

      {props.Data.description && <p>{props.Data.description}</p>}
      {props.Data.quickLinks && (
        <ul>
          {props.Data.quickLinks.map((item, index) =>
            item.pageName.length > 1 ? (
              <li key={index}>
                <a
                  href={item.url}
                  className="stretched-link"
                  target={
                    item.url.indexOf(window.location.host) > -1
                      ? "_self"
                      : "_blank"
                  }
                >
                  <span>{item.pageName}</span>

                  <span className="small chevron chevron-right ml-3"></span>
                </a>
              </li>
            ) : null
          )}
        </ul>
      )}

      {props.Data.buttonText && props.Data.buttonURL && (
        <a
          href={props.Data.buttonURL}
          target={
            props.Data.buttonURL.indexOf(window.location.host) > -1
              ? "_self"
              : "_blank"
          }
          className="button primary yellow"
        >
          {props.Data.buttonText}
        </a>
      )}
    </div>
  );
};

export default LinkBox;
